(() => {
  const init = () => {
    document.querySelectorAll('.iris-header-section details').forEach((details) => {
      if (details.dataset.irisReady) return;
      details.dataset.irisReady = 'true';
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary')?.focus(); event.stopPropagation(); }
      });
      details.addEventListener('toggle', () => {
        if (details.open && details.classList.contains('iris-nav-group')) {
          const nav = details.closest('nav');
          nav?.querySelectorAll('details').forEach((other) => { if (other !== details) other.open = false; });
        }
      });
    });
  };
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.iris-header-section details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', init);
  init();
})();
/* The homepage hands a description to the existing finder without changing its matching rules. */
(() => {
  const initDiscovery = () => {
    document.querySelectorAll('.iris-discovery__form').forEach((form) => {
      if (form.dataset.irisReady) return;
      form.dataset.irisReady = 'true';
      const wish = form.elements.namedItem('wish');
      form.querySelectorAll('[data-iris-wish]').forEach((button) => {
        button.addEventListener('click', () => {
          wish.value = button.dataset.irisWish;
          wish.focus();
        });
      });
      const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewTheme && /^\d+$/.test(previewTheme)) {
        const previewField = document.createElement('input');
        previewField.type = 'hidden';
        previewField.name = 'preview_theme_id';
        previewField.value = previewTheme;
        form.appendChild(previewField);
      }
    });
  };
  const populateFinder = () => {
    const finder = document.querySelector('iris-finder');
    if (!finder || finder.dataset.irisWishHandled) return;
    const wish = new URL(window.location.href).searchParams.get('wish');
    if (!wish || !wish.trim()) return;
    finder.dataset.irisWishHandled = 'true';
    customElements.whenDefined('iris-finder').then(() => {
      if (!finder.isConnected) return;
      const form = finder.querySelector('form');
      const input = form?.elements.namedItem('wish');
      if (!input) return;
      input.value = wish.slice(0, 600);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      form.requestSubmit();
    });
  };
  const init = () => { initDiscovery(); populateFinder(); };
  document.addEventListener('shopify:section:load', init);
  init();
})();

/* Iris artificial display preview styles */
(()=>{if(document.getElementById("iris-tone-styles"))return;const style=document.createElement("style");style.id="iris-tone-styles";style.textContent="iris-tone-preview { display:block;position:absolute;inset:0;pointer-events:none; }\niris-tone-preview[hidden] { display:none!important; }\niris-tone-preview.iris-tone { display:block; position:absolute; inset:0; z-index:5; pointer-events:none; overflow:hidden; color:#142331; font-family:Arial,sans-serif; }\n.iris-tone__stage { position:absolute; inset:0; background:radial-gradient(ellipse at 42% 37%,#faf8f4,#eae5df); opacity:0; transition:opacity .28s ease; }\n.iris-tone__stage>svg { position:absolute; width:100%; height:100%; inset:0; overflow:visible; }\n.iris-tone__heading { position:absolute; left:22px; top:22px; font-size:9px; letter-spacing:.16em; font-weight:500; }\n.iris-tone__note { position:absolute; bottom:18px; left:18px; right:145px; text-align:left; font-size:9px; letter-spacing:.02em; color:#5f625f; }\n.iris-tone__control { position:absolute; right:12px; top:50%; transform:translateY(-50%); display:flex; flex-direction:column; align-items:center; gap:10px; padding:12px 7px; border-radius:30px; background:rgba(255,255,255,.78); box-shadow:0 1px 14px #2332410c; pointer-events:none; visibility:hidden; }\n.iris-tone__control>label { font-size:9px; line-height:1.2; writing-mode:vertical-rl; position:absolute; right:48px; top:50%; transform:translateY(-50%); letter-spacing:.08em; white-space:nowrap; }\n.iris-tone__control input[type=range] { appearance:none; -webkit-appearance:none; writing-mode:vertical-lr; direction:ltr; width:12px; height:130px; margin:0 7px; cursor:ns-resize; background:linear-gradient(to bottom,#fff7ee 0%,#eed1b9 17%,#d2a178 34%,#a76c48 50%,#71422c 67%,#3d231a 84%,#1c1410 100%); border-radius:10px; border:1px solid #a79a8b66; touch-action:none; }\n.iris-tone__control input::-webkit-slider-thumb { appearance:none; -webkit-appearance:none; height:20px; width:20px; border:3px solid white; border-radius:50%; background:#15283b; box-shadow:0 1px 5px #15283b60; }\n.iris-tone__control input::-moz-range-thumb { height:14px; width:14px; border:3px solid white; border-radius:50%; background:#15283b; box-shadow:0 1px 5px #15283b60; }\n.iris-tone__control input:focus-visible { outline:2px solid #15283b; outline-offset:5px; }\n.iris-tone__ends { display:none; }\n.iris-tone__toggle { position:absolute; bottom:12px; right:12px; border:1px solid #bfb8ae; border-radius:24px; padding:8px 12px; background:#fffdf9ed; color:#183046; font:10px/1.2 Arial,sans-serif; letter-spacing:.02em; cursor:pointer; pointer-events:auto; opacity:0; transition:opacity .2s; }\n.iris-tone .iris-tone__toggle { pointer-events:none; visibility:hidden; }\n.iris-tone.is-ready .iris-tone__toggle { opacity:1;pointer-events:auto;visibility:visible; }\n.iris-tone.is-pinned .iris-tone__stage { opacity:1; }\n.iris-tone.is-pinned .iris-tone__control { visibility:visible; pointer-events:auto; }\n\n.iris-tone.is-pinned .iris-tone__heading { display:none; }\n@media(max-width:749px) { .iris-tone__toggle{font-size:9px;padding:7px 9px;right:8px;bottom:8px}.iris-tone__note{font-size:8px;bottom:10px;left:8px;right:8px}.iris-tone__control{right:6px;padding:9px 4px}.iris-tone__control input[type=range]{height:100px;width:10px}.iris-tone__control>label{right:38px;font-size:8px}.iris-tone__heading{font-size:8px;left:12px;top:15px} }\n@media(prefers-reduced-motion:reduce) { .iris-tone__stage,.iris-tone__toggle{transition:none;} }\n.iris-tone[data-context=\"card\"] .iris-tone__note { display:none; }\n.iris-tone.is-dismissed .iris-tone__stage { opacity:0!important; }\n.iris-tone.is-dismissed .iris-tone__control { visibility:hidden!important;pointer-events:none!important; }\n\n@media(max-width:749px) { .iris-tone[data-context=\"product\"] .iris-tone__note { bottom:46px;right:8px; } }\n\n/* Keep preview controls above the card-wide product link. */\n.card__inner:has(> iris-tone-preview) { z-index:2; }\n\n@media(max-width:749px) { .iris-tone[data-context=\"card\"] .iris-tone__toggle { top:8px;bottom:auto; } }\n\n";document.head.append(style);})();
/* Iris display previews: jewellery and display model are independent image layers. */
(() => {
  if (customElements.get('iris-tone-preview')) return;
  const tones = [[255,247,238],[238,209,185],[210,161,120],[167,108,72],[113,66,44],[61,35,26],[28,20,16]];
  const settings = {
    ring: { model: 'hand', x: 398, y: 445, width: 112, rotate: -5 },
    necklace: { model: 'bust', x: 500, y: 200, width: 280, rotate: 0 },
    bracelet: { model: 'wrist', x: 483, y: 650, width: 273, rotate: 41 },
    earring: { model: 'ear', x: 477, y: 692, width: 100, rotate: 0 },
    set: { model: 'bust', x: 500, y: 400, width: 490, rotate: 0 }
  };
  const adjustments = {"1":{"x":500,"y":200,"width":330,"rotate":0},"2":{"x":500,"y":205,"width":280,"rotate":0},"3":{"x":500,"y":200,"width":250,"rotate":0},"4":{"x":500,"y":200,"width":270,"rotate":0},"5":{"x":500,"y":170,"width":250,"rotate":0},"6":{"x":500,"y":180,"width":320,"rotate":-34},"7":{"x":500,"y":180,"width":270,"rotate":0},"8":{"x":500,"y":190,"width":320,"rotate":0},"9":{"x":500,"y":195,"width":270,"rotate":0},"10":{"x":500,"y":190,"width":300,"rotate":0},"11":{"x":500,"y":185,"width":270,"rotate":0},"37":{"width":240,"y":800},"38":{"width":240,"y":800},"39":{"width":260,"y":778}};
  let serial = 0;
  const ns = 'http://www.w3.org/2000/svg';
  function svgElement(name, attributes) {
    const el = document.createElementNS(ns, name);
    for (const [key,value] of Object.entries(attributes || {})) el.setAttribute(key, value);
    return el;
  }
  class IrisTonePreview extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      if (this.dataset.context === 'card' && 'IntersectionObserver' in window) {
        this.previewObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.previewObserver.disconnect();
            this.initializePreview();
          }
        }, {rootMargin:'600px'});
        this.previewObserver.observe(this);
      } else { this.initializePreview(); }
    }
    disconnectedCallback() { if (this.previewObserver) this.previewObserver.disconnect(); }
    initializePreview() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const kind = this.dataset.kind;
      if (!settings[kind] || !this.dataset.jewellery || !this.dataset.model) return;
      const cfg = {...settings[kind], ...(adjustments[this.dataset.index] || {})};
      const displaySource = src => {
        try {
          const url = new URL(src, document.baseURI);
          if ((url.hostname.endsWith('.myshopify.com') || url.hostname === 'cdn.shopify.com') && url.pathname.includes('/files/')) {
            url.searchParams.set('width', this.dataset.context === 'card' ? '600' : '1000');
            return url.href;
          }
        } catch (error) { /* Keep the original source if it is not a URL. */ }
        return src;
      };
      const modelSource = displaySource(this.dataset.model), jewellerySource = displaySource(this.dataset.jewellery);
      const id = `iris-tone-${++serial}`;
      this.classList.add('iris-tone');
      const stage = document.createElement('div'); stage.className = 'iris-tone__stage';
      const svg = svgElement('svg', {viewBox:'0 0 1000 1000', 'aria-hidden':'true', focusable:'false'});
      const defs = svgElement('defs');
      const filter = svgElement('filter', {id, 'color-interpolation-filters':'sRGB', x:'-5%',y:'-5%',width:'110%',height:'110%'});
      const matrix = kind === 'ring' ? svgElement('feColorMatrix', {type:'matrix'}) : null;
      const transfer = matrix ? null : svgElement('feComponentTransfer', {in:'SourceGraphic'});
      const toneChannels = transfer ? ['R','G','B'].map(channel => svgElement(`feFunc${channel}`, {type:'linear',slope:1,intercept:0})) : [];
      if (matrix) { filter.append(matrix); }
      else { transfer.append(...toneChannels,svgElement('feFuncA', {type:'identity'})); filter.append(transfer); }
      defs.append(filter); svg.append(defs);
      const model = svgElement('image', {href:modelSource,x:0,y:0,width:1000,height:1000,filter:`url(#${id})`});
      const jewellery = svgElement('image', {href:jewellerySource,x:cfg.x-cfg.width/2,y:cfg.y-cfg.width/2,width:cfg.width,height:cfg.width,transform:`rotate(${cfg.rotate} ${cfg.x} ${cfg.y})`});
      jewellery.classList.add('iris-tone__jewellery');
      // Cast only a soft contact shadow onto the model; never recolour the jewellery.
      let skinMaskId;
      const contactShadow = source => {
        if (!skinMaskId) {
          skinMaskId = `${id}-contact-skin`;
          const skinMask = svgElement('mask', {id:skinMaskId,x:0,y:0,width:1000,height:1000,maskUnits:'userSpaceOnUse',maskContentUnits:'userSpaceOnUse',style:'mask-type:alpha'});
          skinMask.append(svgElement('image', {href:modelSource,x:0,y:0,width:1000,height:1000}));
          defs.append(skinMask);
        }
        const shadowId = `${id}-contact-shadow`;
        const shadow = svgElement('filter', {id:shadowId,x:-20,y:-20,width:1040,height:1040,filterUnits:'userSpaceOnUse',primitiveUnits:'userSpaceOnUse','color-interpolation-filters':'sRGB'});
        const isEarring = kind === 'earring';
        shadow.append(
          svgElement('feGaussianBlur', {in:'SourceAlpha',stdDeviation:.8,result:'tight-blur'}),
          svgElement('feOffset', {in:'tight-blur',dx:.6,dy:1.2,result:'tight-offset'}),
          svgElement('feFlood', {'flood-color':'#241c16','flood-opacity':isEarring?.17:.20,result:'tight-colour'}),
          svgElement('feComposite', {in:'tight-colour',in2:'tight-offset',operator:'in',result:'tight-shadow'}),
          svgElement('feGaussianBlur', {in:'SourceAlpha',stdDeviation:1.6,result:'soft-blur'}),
          svgElement('feOffset', {in:'soft-blur',dx:1,dy:2.2,result:'soft-offset'}),
          svgElement('feFlood', {'flood-color':'#241c16','flood-opacity':isEarring?.06:.08,result:'soft-colour'}),
          svgElement('feComposite', {in:'soft-colour',in2:'soft-offset',operator:'in',result:'soft-shadow'})
        );
        const merge = svgElement('feMerge');
        merge.append(svgElement('feMergeNode', {in:'soft-shadow'}),svgElement('feMergeNode', {in:'tight-shadow'}));
        shadow.append(merge); defs.append(shadow);
        const cast = svgElement('g', {mask:`url(#${skinMaskId})`,class:'iris-tone__contact-shadow'});
        // Filter this unrotated parent so upper-left lighting stays consistent.
        const projection = svgElement('g', {filter:`url(#${shadowId})`});
        projection.append(source); cast.append(projection);
        return cast;
      };
      const shadowSource = () => {
        const source = jewellery.cloneNode(true);
        source.classList.remove('iris-tone__jewellery');
        source.classList.add('iris-tone__contact-source');
        return source;
      };
      if (kind === 'earring' && ['37','38'].includes(this.dataset.index)) {
        const hoopIndex = this.dataset.index;
        const rear = jewellery.cloneNode(true);
        rear.classList.remove('iris-tone__jewellery');
        rear.classList.add('iris-tone__jewellery-rear');
        const frontMask = svgElement('mask', {id:`${id}-hoop-front`,x:0,y:0,width:1000,height:1000,maskUnits:'userSpaceOnUse',style:'mask-type:luminance'});
        frontMask.append(svgElement('rect',{width:1000,height:1000,fill:'black'}));
        const frontPath = hoopIndex === '37' ? 'M 0 1000 L 1000 1000 L 1000 787 L 510 787 L 481 754 L 476 712 L 471 697 L 448 684 L 430 708 L 425 790 L 0 790 Z' : 'M 477 685 L 481 730 L 496 790 L 497 850 L 469 915 L 0 950 L 0 1000 L 1000 1000 L 1000 685 Z';
        frontMask.append(svgElement('path',{d:frontPath,fill:'white'})); defs.append(frontMask);
        const front = svgElement('g', {mask:`url(#${id}-hoop-front)`}); front.append(jewellery);
        const frontShadowSource = svgElement('g', {mask:`url(#${id}-hoop-front)`}); frontShadowSource.append(shadowSource());
        // Rear arc remains behind the ear. Only the visible front casts onto skin.
        svg.append(rear,model,contactShadow(frontShadowSource),front);
      } else if (kind === 'bracelet' || kind === 'necklace' || kind === 'set') {
        const contact = contactShadow(shadowSource());
        const wrap = svgElement('g', {mask:`url(#${skinMaskId})`}); wrap.append(jewellery);
        svg.append(model,contact,wrap);
      } else if (kind === 'earring') {
        svg.append(model,contactShadow(shadowSource()),jewellery);
      } else { svg.append(model,jewellery); }
      stage.append(svg);
      const heading = document.createElement('span'); heading.className = 'iris-tone__heading'; heading.textContent = 'YOUR TONE. YOUR DETAIL.';
      const note = document.createElement('span'); note.className = 'iris-tone__note'; note.textContent = kind === 'set' ? 'Necklace detail · illustrative display' : 'Illustrative display · not a size guide';
      stage.append(heading,note);
      const control = document.createElement('div'); control.className = 'iris-tone__control';
      const label = document.createElement('label'); label.htmlFor = `${id}-slider`; label.textContent = 'Skin tone';
      const slider = document.createElement('input'); slider.type='range'; slider.min='0'; slider.max='100'; slider.step='1'; slider.value='28'; slider.id=`${id}-slider`; slider.setAttribute('aria-label',`Display skin tone for ${this.dataset.title || 'this piece'}`); slider.setAttribute('aria-orientation','vertical');
      const ends = document.createElement('span'); ends.className='iris-tone__ends'; ends.setAttribute('aria-hidden','true'); ends.innerHTML='<span>Light</span><span>Deep</span>';
      control.append(label,slider,ends); stage.append(control);
      const toggle = document.createElement('button'); toggle.type='button'; toggle.className='iris-tone__toggle'; toggle.textContent='View on a display'; toggle.setAttribute('aria-pressed','false'); toggle.setAttribute('aria-label',`Show display preview for ${this.dataset.title || 'this piece'}`);
      const show = (value) => { this.classList.toggle('is-pinned',value); this.classList.toggle('is-dismissed',!value); toggle.setAttribute('aria-pressed',String(value)); toggle.textContent=value?'Back to jewellery':'View on a display'; toggle.setAttribute('aria-label',`${value?'Back to jewellery':'Show display preview'} for ${this.dataset.title || 'this piece'}`); };
      toggle.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();show(!this.classList.contains('is-pinned'));});
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){show(false); toggle.focus();}});
      control.addEventListener('click',event=>{event.stopPropagation();});
      control.addEventListener('pointerdown',event=>{event.stopPropagation();});
      const updateTone = () => {
        const scaled = Number(slider.value)/100*(tones.length-1), lower=Math.min(Math.floor(scaled),tones.length-2), fraction=scaled-lower;
        const rgb=tones[lower].map((v,i)=>v+(tones[lower+1][i]-v)*fraction);
        if (matrix) {
          matrix.setAttribute('values',`${rgb[0]/229} 0 0 0 0 0 ${rgb[1]/229} 0 0 0 0 0 ${rgb[2]/229} 0 0 0 0 0 1 0`);
        } else {
          // Reveal the display's lit planes at deeper tones while keeping rich brown shadows.
          const reflectionStrength = Number(slider.value) <= 50 ? 0 : Math.pow(Math.max(0,Math.min(1,(72-rgb[2])/56)),1.3);
          const reflectionRgb = [70,56,46.2];
          toneChannels.forEach((fn,channel) => {
            if (!reflectionStrength) {
              fn.setAttribute('type','linear'); fn.setAttribute('slope',rgb[channel]/229); fn.removeAttribute('tableValues');
            } else {
              // Begin gradually above source143.44; the darkest folds retain their original depth.
              const values = Array.from({length:33},(_,point) => {
                const source = point/32;
                const highlight = Math.pow(Math.max(0,(point-18)/14),1.5);
                return (source*rgb[channel]/229 + (reflectionRgb[channel]/255)*reflectionStrength*highlight).toFixed(7);
              });
              fn.setAttribute('type','table'); fn.setAttribute('tableValues',values.join(' ')); fn.removeAttribute('slope');
            }
          });
        }
        const value=Number(slider.value); slider.setAttribute('aria-valuetext',value<17?'Very light':value<34?'Light':value<50?'Medium':value<67?'Tan':value<84?'Deep':'Very deep');
      };
      slider.addEventListener('input',updateTone); updateTone();
      this.append(stage,toggle);
      const sources=[modelSource,jewellerySource];
      Promise.all(sources.map(src=>new Promise((resolve,reject)=>{const img=new Image();img.onload=resolve;img.onerror=reject;img.src=src;}))).then(()=>this.classList.add('is-ready')).catch(()=>{this.hidden=true;});
    }
  }
  customElements.define('iris-tone-preview',IrisTonePreview);
})();

/* Keep navigation present without obscuring the collection. */
(function(){
 function initialiseIrisNavigation(){
  var header=document.querySelector('.iris-header-section');
  if(header&&!header.dataset.irisCompactReady){
   header.dataset.irisCompactReady='true';
   var pending=false;
   function updateHeader(){
    var y=window.scrollY||0;
    if(y>160)header.classList.add('is-condensed');
    else if(y<32)header.classList.remove('is-condensed');
    pending=false;
   }
   window.addEventListener('scroll',function(){if(!pending){pending=true;window.requestAnimationFrame(updateHeader);}},{passive:true});
   window.addEventListener('pageshow',updateHeader);
   updateHeader();
  }
  var paths={'↗':'M5 19 19 5M5 5h14v14','→':'M4 12h16m-6-6 6 6-6 6','↓':'M12 4v16m-6-6 6 6 6-6'};
  document.querySelectorAll('.iris-footer span[aria-hidden="true"]').forEach(function(span){
   var path=paths[span.textContent.trim()];if(!path)return;
   var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
   Object.entries({'class':'iris-ui-arrow','width':'20','height':'20','viewBox':'0 0 24 24','fill':'none','stroke':'currentColor','stroke-width':'1.5','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true','focusable':'false'}).forEach(function(pair){svg.setAttribute(pair[0],pair[1]);});
   var line=document.createElementNS('http://www.w3.org/2000/svg','path');line.setAttribute('d',path);svg.appendChild(line);span.replaceWith(svg);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialiseIrisNavigation);else initialiseIrisNavigation();
 document.addEventListener('shopify:section:load',initialiseIrisNavigation);
})();

/* Keep the bag link's accessible count aligned with Shopify's replaced icon contents. */
(() => {
 const key='__irisCartCountA11y';
 if(window[key]){window[key]();return;}
 let link,observer;
 const sync=()=>{
  if(!link)return;
  let count;
  for(const text of link.querySelectorAll('.visually-hidden')){
   const match=text.textContent.trim().match(/^([\d,]+)\s+items?\b/i);
   if(match){count=Number(match[1].replace(/,/g,''));break;}
  }
  if(!Number.isSafeInteger(count)){
   const badge=link.querySelector('.iris-cart-count')?.textContent.trim();
   if(badge&&/^[\d,]+$/.test(badge))count=Number(badge.replace(/,/g,''));
  }
  const label=Number.isSafeInteger(count)&&count>=0?'Shopping bag, '+count+' '+(count===1?'item':'items'):'Shopping bag';
  if(link.getAttribute('aria-label')!==label)link.setAttribute('aria-label',label);
 };
 const init=()=>{
  const current=document.getElementById('cart-icon-bubble');
  if(current===link){sync();return;}
  observer?.disconnect();link=current;if(!link)return;sync();
  observer=new MutationObserver(sync);
  observer.observe(link,{childList:true,subtree:true,characterData:true});
 };
 window[key]=init;
 document.addEventListener('shopify:section:load',init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/* Iris: document progress, attached to the existing header without layout changes. */
(() => {
  const key = '__irisScrollProgress';
  if (window[key]) {
    window[key]();
    return;
  }

  let header;
  let track;
  let fill;
  let frame = 0;
  let lastProgress = -1;
  let observing = false;

  const mount = () => {
    const current = document.querySelector('.iris-header-section');
    if (current === header && track?.isConnected && fill?.isConnected) return;
    header = current;
    track = null;
    fill = null;
    lastProgress = -1;
    if (!header) return;

    track = header.querySelector(':scope > .iris-scroll-progress');
    if (!track) {
      track = document.createElement('span');
      track.className = 'iris-scroll-progress';
      track.setAttribute('aria-hidden', 'true');
      header.appendChild(track);
    }
    fill = track.querySelector('.iris-scroll-progress__fill');
    if (!fill) {
      fill = document.createElement('span');
      fill.className = 'iris-scroll-progress__fill';
      track.appendChild(fill);
    }
  };

  const update = () => {
    frame = 0;
    mount();
    if (!fill) return;
    const root = document.documentElement;
    const scroller = document.scrollingElement || root;
    const height = Math.max(scroller.scrollHeight, root.scrollHeight, document.body?.scrollHeight || 0);
    const range = height - (root.clientHeight || window.innerHeight);
    const top = window.scrollY ?? scroller.scrollTop;
    // A page with no meaningful scroll range has no progress line.
    const progress = range > 1 ? Math.max(0, Math.min(1, top / range)) : 0;
    if (progress !== lastProgress) {
      fill.style.transform = `scaleX(${progress})`;
      lastProgress = progress;
    }
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  const init = () => {
    if (!observing && document.body) {
      observing = true;
      if ('ResizeObserver' in window) {
        const sizes = new ResizeObserver(schedule);
        sizes.observe(document.documentElement);
        sizes.observe(document.body);
      }
      // Covers added content and header replacement, including theme-editor reloads.
      // No attribute observation: our transform updates cannot feed back into it.
      const content = new MutationObserver(schedule);
      content.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    schedule();
  };

  window[key] = init;
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', init);
  document.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* Iris: a brief crossfade between real product photographs; controls stay still. */
(() => {
  if (window.irisPhotoCrossfadeReady) return;
  window.irisPhotoCrossfadeReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const galleries = new Map();
  const imageSelector = '.product__media-item.is-active .product__media > img:not(.iris-photo-crossfade)';
  const identity = (source) => {
    try {
      const url = new URL(source, document.baseURI);
      ['width', 'height', 'crop'].forEach((key) => url.searchParams.delete(key));
      return url.href;
    } catch (_) { return source; }
  };
  const photograph = (gallery) => {
    const image = gallery.querySelector(imageSelector);
    if (!image) return null;
    const source = image.currentSrc || image.src;
    return { image, source, key: identity(source), fit: getComputedStyle(image).objectFit,
      preview: !!image.closest('.product__media-item').querySelector('iris-tone-preview.is-pinned') };
  };
  const init = () => {
    for (const [gallery, state] of galleries) {
      if (!gallery.isConnected) {
        state.cancel();
        state.observer.disconnect();
        galleries.delete(gallery);
      }
    }
    document.querySelectorAll('product-info media-gallery').forEach((gallery) => {
      if (!gallery.isConnected || galleries.has(gallery)) return;
      let previous = photograph(gallery);
      let cancel = () => {};
      const update = () => {
        const next = photograph(gallery);
        if (!next) { cancel(); previous = null; return; }
        const before = previous;
        previous = next;
        if (!before || before.key === next.key) return;
        cancel();
        if (reducedMotion.matches || !next.image.animate || before.preview || next.preview) return;
        const holder = next.image.parentElement;
        const overlay = document.createElement('img');
        overlay.className = 'iris-photo-crossfade';
        overlay.src = before.source;
        overlay.alt = '';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.style.objectFit = before.fit || 'contain';
        holder.append(overlay);
        let stopped = false;
        let frame = 0;
        let animations = [];
        const stop = () => {
          if (stopped) return;
          stopped = true;
          clearTimeout(expiry);
          cancelAnimationFrame(frame);
          next.image.removeEventListener('load', begin);
          next.image.removeEventListener('error', stop);
          animations.forEach((animation) => animation.cancel());
          overlay.remove();
        };
        const begin = () => {
          if (stopped) return;
          if (!gallery.isConnected || photograph(gallery)?.key !== next.key || reducedMotion.matches) {
            stop(); return;
          }
          frame = requestAnimationFrame(() => {
            if (stopped) return;
            const options = { duration: 200, easing: 'ease-out' };
            animations = [
              next.image.animate([{ opacity: 0 }, { opacity: 1 }], options),
              overlay.animate([{ opacity: 1 }, { opacity: 0 }], options)
            ];
            Promise.all(animations.map((animation) => animation.finished)).then(stop, stop);
          });
        };
        const expiry = setTimeout(stop, 1800);
        cancel = stop;
        if (next.image.complete && next.image.naturalWidth) begin();
        else {
          next.image.addEventListener('load', begin, { once: true });
          next.image.addEventListener('error', stop, { once: true });
        }
      };
      const observer = new MutationObserver((changes) => {
        if (changes.some(({ target }) => target.matches?.('.product__media-item, .product__media > img:not(.iris-photo-crossfade)'))) update();
      });
      observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class', 'src', 'srcset'] });
      galleries.set(gallery, { observer, cancel: () => cancel() });
    });
  };
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) galleries.forEach((state) => state.cancel());
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  document.addEventListener('product-info:loaded', init);
  window.addEventListener('pagehide', () => galleries.forEach((state) => state.cancel()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(function () {
  'use strict';
  if (window.__irisSizingValidationReady) return;
  window.__irisSizingValidationReady = true;

  // Capture invalid submissions before the existing product-form AJAX listener.
  // Delegation also covers forms rendered again after a product option changes.
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const fields = Array.from(form.querySelectorAll('[data-iris-sizing-input]'));
    if (!fields.length) return;

    const invalid = fields.find(function (field) { return !field.checkValidity(); });
    if (invalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalid.reportValidity();
      return;
    }

    // Keep the order property readable even if a number was entered as 7.00 or 1e1.
    fields.forEach(function (field) {
      if (field.type === 'number' && Number.isFinite(field.valueAsNumber)) {
        field.value = String(field.valueAsNumber);
      }
    });
  }, true);
}());

// Native accelerated checkout reads the selected variant, quantity and fit from its product form.
(function () {
  'use strict';
  if (window.__irisExpressCheckoutReady) return;
  window.__irisExpressCheckoutReady = true;
  function stateFor(form) {
    const fields = Array.from(form.elements).filter(function (field) { return field.matches?.('[data-iris-sizing-input], input[name="quantity"]'); });
    const invalid = fields.find(function (field) { return field.willValidate && !field.validity.valid; });
    const variant = form.elements.namedItem('id');
    const addButton = form.querySelector('button[name="add"]');
    const unavailable = !variant?.value || variant.disabled || !addButton || addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
    return { fields: fields, invalid: invalid, unavailable: unavailable };
  }
  function sync(form) {
    const checkout = form.querySelector('[data-iris-express-checkout]');
    if (!checkout) return;
    const state = stateFor(form);
    const blocked = Boolean(state.invalid || state.unavailable);
    checkout.hidden = blocked;
    checkout.inert = blocked;
    const note = form.querySelector('[data-iris-express-note]');
    if (note) {
      note.hidden = !state.invalid || state.unavailable;
      const text = state.invalid?.matches('[data-iris-sizing-input]') ? 'Choose your fit above to enable express checkout.' : 'Choose a valid quantity above to enable express checkout.';
      if (note.textContent !== text) note.textContent = text;
    }
    return state;
  }
  function syncAll() {
    document.querySelectorAll('[data-iris-express-checkout]').forEach(function (checkout) { const form = checkout.closest('form'); if (form) sync(form); });
  }
  function onFieldChange(event) { const form = event.target.form; if (form) sync(form); }
  document.addEventListener('input', onFieldChange);
  document.addEventListener('change', onFieldChange);
  document.addEventListener('click', function (event) {
    const checkout = event.target.closest?.('[data-iris-express-checkout]');
    const form = checkout?.closest('form');
    if (!form) return;
    const state = sync(form);
    if (state.invalid || state.unavailable) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (state.invalid) state.invalid.reportValidity();
      return;
    }
    state.fields.forEach(function (field) { if (field.matches('[data-iris-sizing-input]') && field.type === 'number' && Number.isFinite(field.valueAsNumber)) field.value = String(field.valueAsNumber); });
  }, true);
  function init() {
    syncAll();
    new MutationObserver(function (records) {
      if (records.some(function (record) { return record.type === 'childList' || record.target.matches?.('button[name="add"], input[name="id"], input[name="quantity"], [data-iris-sizing-input]'); })) syncAll();
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'min', 'max', 'step', 'value', 'required'] });
  }
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('product-info:loaded', syncAll);
  window.addEventListener('pageshow', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
}());
